module.exports = __webpack_public_path__ + "img/iniciar_chamada.4728cddd.gif";